/*
|---------------------------------------------------
| Setting up polyfills to support old IE versions
|---------------------------------------------------
*/

import 'babel-polyfill'
import 'utils'

import fetch from 'whatwg-fetch'

if (!window.fetch) {
  window.fetch = fetch
}

/*
|---------------------------------------------------
| Importing and setting up base Vue
|---------------------------------------------------
*/
import Vue from 'vue'

import AsyncComputed from 'vue-async-computed/dist/vue-async-computed.js'

Vue.use(AsyncComputed)

import VueFilter from 'vue-filter'

Vue.use(VueFilter)

import VueProgressBar from 'vue-progressbar/dist/vue-progressbar.js'

Vue.use(VueProgressBar, {
  color: 'rgb(32, 160, 255)',
  failedColor: 'red',
  height: '2px'
})

/*
|---------------------------------------------------
| Initializing ElementUI
|---------------------------------------------------
*/
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'assets/custom.scss'

Vue.use(ElementUI)

/*
|---------------------------------------------------
| Initializing localization
|---------------------------------------------------
*/
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import hu from 'lang/hu_hu'
import en from 'lang/en_us'

Vue.locale('hu', hu)
Vue.locale('en', en)

import locale from 'element-ui/lib/locale'

/*
|---------------------------------------------------
| Initializing websocket client
|---------------------------------------------------
*/

import 'providers/socket'

/*
|---------------------------------------------------
| Initializing one-way dataflow
|---------------------------------------------------
*/

import store from 'store'

/*
|---------------------------------------------------
| Initializing application routes
|---------------------------------------------------
*/

import router from 'router'

/*
|---------------------------------------------------
| Initializing Vue app
|---------------------------------------------------
*/

import App from 'App'
import 'mixin'

import DataForm from 'components/DataForm'
import DataTable from 'components/DataTable'
import FaIcon from 'components/FaIcon'

Vue.component(DataForm.name, DataForm)
Vue.component(DataTable.name, DataTable)
Vue.component(FaIcon.name, FaIcon)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  router,
  store,
  components: { App },
  created () {
    const lang = window.localStorage.lang || 'en'

    Vue.config.lang = lang
    locale.use(lang)
  }
})



// WEBPACK FOOTER //
// ./src/main.js